import{b as D,c as m}from"./utils--8rlMPY4.js";const X=r=>{const a=new Set;return r.forEach(t=>{const n=(t.products?t.products[0]:t).custom,l=(n==null?void 0:n.product_sets_top)||[],o=(n==null?void 0:n.products_sets_bottom)||[];[...l,...o].forEach(i=>{i.id&&a.add(i.id)})}),[...a]},K=async r=>{var s,d;if(!r.length)return{};const a="https://nobodyschild.myshopify.com/api/2025-04/graphql.json",t=window.themeVars.storefrontApiToken,[,e]=window.location.pathname.split("/"),l=((e||"").split("-")[1]||"gb").toUpperCase(),o=r.map(c=>`gid://shopify/Product/${c}`),i=`
    query GetSetProductPrices($ids: [ID!]!) @inContext(country: ${l}) {
      nodes(ids: $ids) {
        ... on Product {
          id
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
          }
        }
      }
    }
  `;try{const h=await(await fetch(a,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":t},body:JSON.stringify({query:i,variables:{ids:o}})})).json(),u={};return(d=(s=h.data)==null?void 0:s.nodes)==null||d.forEach(p=>{if(p!=null&&p.id){const _=p.id.replace("gid://shopify/Product/","");u[_]=parseFloat(p.priceRange.minVariantPrice.amount)}}),u}catch(c){return console.error("Failed to fetch set product prices:",c),{}}},H=(r,a)=>{if(!a||!Object.keys(a).length)return null;const t=r.custom,e=(t==null?void 0:t.product_sets_top)||[],n=(t==null?void 0:t.products_sets_bottom)||[],l=[...e,...n];if(!l.length)return null;let o=1/0;return l.forEach(i=>{const s=a[i.id];s!==void 0&&s<o&&(o=s)}),o===1/0?null:o},O=r=>{if(!Array.isArray(r)||r.length===0)return"";const a=new Map;return r.forEach(t=>{const e=t==null?void 0:t.url,n=Number(t==null?void 0:t.width);!e||!Number.isFinite(n)||n<=0||a.has(n)||a.set(n,e)}),a.size===0?"":[...a.entries()].sort(([t],[e])=>t-e).map(([t,e])=>`${e} ${t}w`).join(", ")},q=(r,a)=>{var l;if(!Array.isArray(r)||r.length===0)return a||"";const t=r.filter(o=>(o==null?void 0:o.url)&&Number(o==null?void 0:o.width)>0);if(t.length===0)return((l=r[0])==null?void 0:l.url)||a||"";const e=600;return t.reduce((o,i)=>{const s=Math.abs(Number(o.width)-e);return Math.abs(Number(i.width)-e)<s?i:o}).url},Q=(r,{isSlide:a=!1,index:t=99,setProductPrices:e={}}={})=>{var S,P,C,I,A,F,z,N,V,x,M,T;const{key:n,title:l,link:o,imageInfo:i,sellingPrice:s,listPrice:d,custom:c,ticket:h}=r,u=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",p=((P=(S=i==null?void 0:i.images)==null?void 0:S[0])==null?void 0:P.sources)||[],_=q(p,i==null?void 0:i.thumbnail),g=O(p),j="(min-width: 1024px) 25vw, 50vw",y=(s==null?void 0:s.min)||0,w=(d==null?void 0:d.min)>(s==null?void 0:s.min)?d.min:0,f=(I=(C=c==null?void 0:c.product_hover_image)==null?void 0:C[0])==null?void 0:I.label,b=(F=(A=c==null?void 0:c.colour_count)==null?void 0:A[0])==null?void 0:F.label,$=(N=(z=c==null?void 0:c.collaboration_name)==null?void 0:z[0])==null?void 0:N.label,k=D((x=(V=c==null?void 0:c.collaboration_link)==null?void 0:V[0])==null?void 0:x.label),E=t<=2?"eager":"lazy",L=t<=2?"high":"auto",v=((M=c==null?void 0:c.product_sets_top)==null?void 0:M.length)>0||((T=c==null?void 0:c.products_sets_bottom)==null?void 0:T.length)>0?H(r,e):null;return`
    <${a?"li":"div"}
      class="product-card ${a?"splide__slide":""}"
      data-voyado-product
      data-product-key="${n}"
      data-product-ticket="${h}"
    >
      ${G(c,y,w)}
      ${R(r)}
      <a
        href="${u}${o}"
        class="product-card__image-container ${f?"has-hover":""}"
        aria-label="${l}"
      >
        <img
          src="${_}"
          ${g?`srcset="${g}" sizes="${j}"`:""}
          alt="Image of ${l}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${E}"
          fetchpriority="${L}"
        />
        ${f?`
          <img
            src="${f}"
            alt="Secondary image of ${l}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <div class="product-card__title-wrapper">
          <p class="product-card__title f1-lc">${l}</p>
          ${$?k?`<a href="${k}" class="product-card__collaboration f2-uc">${$}</a>`:`<p class="product-card__collaboration f2-uc">${$}</p>`:""}
        </div>
        ${v!==null?W(v):B(y,w)}
      </div>
       <p
        data-product-id="${n}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${b&&b>1?`
        <p class="product-card__colour-count f2-lc">
          ${b} Colours
        </p>
      `:""}
    </${a?"li":"div"}>
  `},W=r=>`
    <div class="product-card__price">
      <span class="product-card__price--current f1-lc">
        From ${m(r)}
      </span>
    </div>`,B=(r,a)=>{let t="",e="product-card__price--current";return a&&(t=`
      <span class="product-card__price--original f1-lc">
        ${m(a)}
      </span>
    `,e="product-card__price--discounted"),`
    <div class="product-card__price">
      ${t}
      <span class="${e} f1-lc">
        ${m(r)}
      </span>
    </div>`},G=(r,a,t)=>{if(a&&t&&a<t)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-a/t)*100)}% OFF
      </p>
    `;const e=l=>{var i,s;const o=(s=(i=r==null?void 0:r[l])==null?void 0:i[0])==null?void 0:s.label;return o&&!o.includes("-")?o:""},n=e("stock")||e("petite")||e("collection")||e("new")||e("back_in_stock")||e("available_to_rent")||e("nc_exclusive");return n?`
      <p class="product-card__label product-label product-label--default">
        ${n}
      </p>
    `:""},R=r=>{var t;const a=((t=r.link)==null?void 0:t.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${r.key}"
      data-product-handle="${a}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{Q as b,X as c,K as f};
